import type { Pagination } from '~/types/utility'

export interface UpdateViewAsDatePayload {
  viewAsDate: string | null
}

export interface ImpersonatePayload {
  email: string
}

// clearImpersonation got the agent back (agent/clear-impersonation landed and the context is
// cleared) but a refresh after it failed. The original error is the cause. A caller that needs to
// know whether the agent is back checks for this instead of reading store state. AB#64477
export class ImpersonationRefreshError extends Error {
  constructor (options?: { cause?: unknown }) {
    super('Impersonation cleared, but a refresh after it failed', options)
    this.name = 'ImpersonationRefreshError'
  }
}

export interface ItemAvailabilityParams {
  audience: string,
  viewAsDate: string | null,
  culture: string | null,
  excludeFrom: string | null,
  exclusiveTo: string | null,
  lifeCycleState: string | null,
  category: string | null,
  itemIds: string | null
}

export interface SubscriptionAuditUser {
  userId: string
  subscriptionId: string
  recurlySubscriptionId: string
  subscriptionName: string
  nextBill: string
  recipient: string
  status: string
  demo: string
}

export interface SubscriptionAuditUsersResponse extends Pagination {
  results: SubscriptionAuditUser[]
  customerName: string
}

export interface SubscriptionAuditDetail {
  userId: string
  subscriptionId: string
  action: string
  auditDate: string
  modifiedBy: string
  oldValue: string
  newValue: string
}

export interface SubscriptionAuditDetailResponse extends Pagination {
  results: SubscriptionAuditDetail[]
  subscriptionName: string
  recurlySubscriptionId: string
  isGift: boolean
  customerName: string
  status: string
}
